import React from 'react';
import { Link } from 'react-router-dom';

import Header from '../../components/header';
import Footer from '../../components/footer';
import imgWindows from '../../assets/janelas.svg';
import imgCertificate from '../../assets/contrato.svg';
import imgBrowser from '../../assets/navegador.svg';
import imgJava from '../../assets/java.svg';

import 'bootstrap/dist/css/bootstrap.min.css';
import './styles.css';

export default function Renew() {
  return (
    <>
      <Header content="Renovação Online" />
      <div className="renew-container container">
        <div className="row justify-content-center">
          <h2>Requisitos Mínimos</h2>
        </div>
        <div className="renew-content">
          <div className="row mb-5">
            <div className="col-6">
              <div className="row align-items-center justify-content-center">
                <div className="col-4 mr-1">
                  <img src={imgWindows} alt="" />
                </div>
                <div className="col-6">
                  <p>Windows 7 ou superior</p>
                </div>
              </div>
            </div>
            <div className="col-6">
              <div className="row align-items-center justify-content-center">
                <div className="col-4 mr-1">
                  <img src={imgBrowser} alt="" />
                </div>
                <div className="col-6">
                  <p>Internet Explorer 11</p>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <div className="row align-items-center justify-content-center">
                <div className="col-4 mr-1">
                  <img src={imgJava} alt="" />
                </div>
                <div className="col-6">
                  <p>Última versão do Java 32bits</p>
                </div>
              </div>
            </div>
            <div className="col-6">
              <div className="row align-items-center justify-content-center">
                <div className="col-4 mr-1">
                  <img src={imgCertificate} alt="" />
                </div>
                <div className="col-6">
                  <p>Ter em mãos o certificado A3 (token ou cartão)</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-around mt-4">
          <Link to="/options" className="button-renew btn" >Voltar</Link>
          <a
            href="https://sigcertificadora.com.br/renovacao"
            className="button-renew btn"
          >
            RENOVAR
          </a>
          
        </div>
      </div>
      <Footer />
    </>
  );
}
